import React from 'react';
import { IFormField, FieldType } from '@topshots/core-models';
import { FormGroup } from '../forms/form-group';
import { ErrorText } from '../forms/error-text';
import { FormFieldRenderer } from './form-field-renderer';

interface FormRendererProps {
  fields: IFormField[];
  values: Record<string, any>;
  errors?: Record<string, string>;
  onChange: (fieldId: string, value: any) => void;
  formikPath: (field: IFormField) => string;
}

export const FormRenderer: React.FC<FormRendererProps> = ({
  fields,
  values,
  errors,
  onChange,
  formikPath,
}) => {
  return (
    <div>
      {fields.map((field) => (
        <FormGroup key={field.id}>
          {field.type !== FieldType.Checkbox && (
            <label htmlFor={field.id}>
              {field.label}
              {field.required && <span className="text-danger">*</span>}
            </label>
          )}
          {
            <FormFieldRenderer
              formikPath={formikPath(field)}
              field={field}
              value={values[field.id] ?? ''}
              onChange={(newValue) => {
                onChange(field.id, newValue);
              }}
            />
          }
          {/* {renderField(field)} */}
          {errors?.[field.id] && <ErrorText>{errors[field.id]}</ErrorText>}
        </FormGroup>
      ))}
    </div>
  );
};
